module.exports = __webpack_public_path__ + "static/img/back-9-1.c56cd966.png";